import './About.css';
import { Header } from '../../header/Header';
import missionImage from "../../assets/mission.jpeg";
import visionImage from "../../assets/vision.jpeg";
import nalini from "../../assets/nalini.jpeg";
import sunita from "../../assets/sunita.jpeg";
import shekhar from "../../assets/shekhar.jpeg";
import sonali from "../../assets/sonali.jpeg";
import bhushan from "../../assets/bhushan.jpeg";
import neha from "../../assets/neha.jpeg";
import arvind from "../../assets/arvind.jpeg";
import rashmi from "../../assets/rashmi.jpeg";
import gourav from "../../assets/gourav.jpeg";
import varsha from "../../assets/varsha.jpeg";
import a1 from "../../assets/a1.jpg";
import a2 from "../../assets/a2.png";
import a3 from "../../assets/a3.jpg";
import { Footer } from '../footer/Footer';

export const About = () => {

  const teamMembers = [
    {
      name: 'Ms. Nalini Sakat',
      title: 'Child Psychologist/ Special Educator',
      role: 'Counselling Psychologist',
      image: nalini
    },
    {
      name: 'Ms. Sunita Pandey',
      title: 'Counselling Psychologist',
      role: 'Psychotherapist',
      image: sunita
    },
    {
      name: 'Mr. Shekhar Patil',
      title: 'Special Educator',
      role: 'Occupational Therapist',
      image: shekhar
    },
    {
      name: 'Mr. Arvind Sonwane',
      title: 'B.Ed (H.I) Speech Therapist',
      role: '19+ Years of Experience',
      image: arvind
    },
    {
      name: 'Mrs. Rashmi Pawar',
      title: 'Counselling Psychologist',
      role: '/ Psychotherapist',
      image: rashmi
    },
    {
      name: 'Mrs. Sonali Jadhav',
      title: 'Clinical Psychologist',
      role: 'We conduct IQ test, EQ test, Personality test, career testing.',
      image: sonali
    },
    {
      name: 'Mr. Bhushan Honrao',
      title: 'M.Phill in Clinical Psychology',
      role: 'Psychological Assessment (WISC,WAPIS,MISIC,BKT and so on…)',
      image: bhushan
    },
    {
      name: 'Ms. Neha Joshi',
      title: 'M.Phil. Clinical Psychology',
      role: '',
      image: neha
    },
  ];

  const collaborators = [
    {
      name: 'Dr. Gourav Trivedi',
      title: 'Psychiatrist',
      image: gourav
    },
    {
      name: 'Dr. Varsha Dawani',
      title: 'Psychiatrist',
      image: varsha
    }
  ];

    return (
        <>
          <Header/>
          <div className="about-us">
            <div className="about-header">
              <h1>ABOUT US</h1>
            </div>
            <div className="about-section">
        <img src={missionImage} alt="Mission" className="about-image" />
        <div className="about-text">
          <h2>Mission</h2>
          <p>
            Our aim is to provide compassionate and culturally sensitive counseling services
            to individuals of all age groups, any background, and abilities. Here we foster a
            safe and nonjudgmental environment that promotes self-exploration, personal
            insights, and self-awareness. We utilize evidence-based approaches and
            psychological interventions to address a wide range of psychological, emotional,
            and behavioral concerns. Our team conducts ongoing research to contribute to the
            advancement of counseling psychology and enhance the quality of treatment.
          </p>
        </div>
            </div>

            <div className="about-section">
              <div className="about-text">
                <h2>Vision</h2>
                <p>
                  To empower individuals, families, and communities to achieve emotional well-being,
                  personal growth, and meaningful relationships through evidence-based counseling
                  interventions, advocacy, therapeutic approaches and holistic support.
                  In Happy Faces, we strive for continuous professional development and adherence to
                  ethical guidelines, ensuring the highest standards of competence and integrity for
                  delivering our services.
                </p>
              </div>
              <img src={visionImage} alt="Vision" className="about-image" />
            </div>
            
            {/* Team Section */}
            <div className="team-section">
              <h2 className="team-heading">Our Team</h2>
              <p className="team-subheading">
                Your mind is powerful thing. When you start to filter it with positive thoughts your life will start to change.
              </p>
              <div className="team-grid">
                {teamMembers.map((member, index) => (
                  <div className="team-member" key={index}>
                    <img src={member.image} alt={member.name} className="team-photo" />
                    <h3>{member.name}</h3>
                    <p><em>{member.title}</em></p>
                    <p>{member.role}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Collaboration With Section */}
            <div className="collab-section">
              <h2 className="collab-heading">Collaboration With</h2>
              <div className="collab-grid">
                {collaborators.map((person, index) => (
                  <div className="collab-card" key={index}>
                    <img src={person.image} alt={person.name} className="collab-photo" />
                    <h3>{person.name}</h3>
                    <p>{person.title}</p>
                  </div>
                ))}
              </div>
            </div>
              
            {/* Help Section */}
            <div className="help-section">
              <h2 className="help-heading">We are here to help you...</h2>
              <a href="/contact" className="help-button">GETTING STARTED</a>
              <div className="help-images">
                <img src={a1} alt="Therapy session" className="help-image" />
                <img src={a2} alt="Happy client" className="help-image middle" />
                <img src={a3} alt="Counseling" className="help-image" />
              </div>
            </div>
          </div>

          <Footer />
        </>
      );  
};